import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merge Tailwind classes, resolving conflicts by last-wins.
 *
 * Plain string concatenation would leave both `p-2` and `p-4` in the class list
 * and let CSS source order decide. `twMerge` keeps the one the caller actually
 * asked for, which is what makes a `className` prop on a component mean
 * something.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
